<template>
    <div class="page-layout blank contacts-manage">
        <div class="pb-10 pl-3 pr-3">
            <h2 class="ml-0 mb-0 mt-0">
                <div class="d-flex flex-wrap justify-content-between">
                    <!-- Breadcrumb Section -->
                    <div class="breadcrumbactive">
                        <div>
                            <span><router-link to="/deals/viewdeals/list" class="text-white pl-2 text-line">Deals</router-link></span>
                            <div>Create Deal</div>
                            <!-- <div>{{ $route.params.id == 'new' ? 'Create Deals' : 'Edit Deals'}}</div> -->
                        </div>
                    </div>
                </div>
            </h2>
            <div class="d-flex align-items-center justify-content-center h-100" v-if="ajaxCallInProgress">
                <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
            </div>
            <div v-else class="start-overflow">
                <div class="create-company-container w-100">
                    <!-- Deal Information Section -->
                    <div class="main-div">
                        <div class="create-company-header d-flex align-items-center justify-content-between">
                            <span class="fs-14  pl-4 text-white ml-8 fw-500">Deal Information</span>
                            <span class="pointer pt-2" @click="showDealInfo">
                                <i v-if="!show_deals_details" class="icon-chevron-double-up text-white fw-500 fs-20"></i>
                                <i v-else class="icon-chevron-double-down text-white fw-500 fs-20"></i>
                            </span>
                        </div>
                        <div v-if="show_deals_details">
                            <div class="mt-6 px-10" >
                                <div  class="pt-6 pl-6 pr-6 pb-2">
                                    <div class="row">
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div class="w-100">
                                                <span class="input-label">Deal Name<sup class="fs-14 pl-1 text-danger">*</sup></span>
                                                <div class="d-flex align-content-center mt-2">
                                                    <input type="text" ref="deal_nameInput" maxlength="200" name="deal_name" v-validate="'required'" class="input-field input-width" v-model="deal_name" placeholder="Enter Deal Name" />
                                                </div>
                                                <div class="text-right">
                                                    <span class="float-left text-danger mb-3" v-show="errors.has('deal_name')">{{errors.first('deal_name')}}</span>
                                                    <span class="input-field-length float-right">{{ deal_name.length }}/200</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div class="w-100">
                                                <span class="input-label">Owner Name<sup class="fs-14 pl-1 text-danger">*</sup></span>
                                                <div class="d-flex align-content-center mt-2">
                                                    <input type="text" name="owner_name" disabled class="input-field input-width" v-validate="'required'" v-model="owner_name" placeholder="Enter Owner Name" />
                                                    <span class="mt-4 ml-1">
                                                        <span class="mt-3"><i class="icon text-green icon-check-circle"></i></span>
                                                    </span>
                                                </div>
                                                <div class="text-right pr-10">
                                                    <span class="float-left text-danger mb-3" v-show="errors.has('owner_name')">Owner Name is Required</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div>
                                                <span class="input-label">Salesperson Name<sup class="fs-14 pl-1 text-danger">*</sup></span>
                                                <div class="d-flex">
                                                    <multiselect
                                                    class="diginew-multiselect salesperson-multiselect new-align-multi no-default-icon down-arrow mt-2"
                                                    placeholder="Select Salesperson" v-validate="'required'" track-by="sales_person_id"
                                                    v-model="salesperson_name" name="sales_person" label="sales_person_name"
                                                    :loading="salesperson_loading" @open="loadSalespersonList"
                                                    :options="salesperson_name_options" @search-change="loadSalespersonList"
                                                    :multiple="true" :searchable="true" :internal-search="true"
                                                    :clear-on-select="true" :close-on-select="false" :options-limit="300"
                                                    :max-height="200" :show-no-results="true" :hide-selected="false"
                                                    :blockKeys="['Delete']"
                                                    :limit="1" :limit-text="limitSalespersonsTo">
                                                        <template slot="tag" slot-scope="{ option }">
                                                            <span class="custom__tag">
                                                            <span class="filterSelectedName">{{ option.sales_person_name }}</span>
                                                                <span class="custom__remove pointer" @click="removeSalesperson(option)">
                                                                <i class="icon icon-close fs-16 text-white"></i>
                                                                </span>
                                                            </span>
                                                        </template>
                                                        <template slot="noResult">
                                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                                        </template>
                                                        <template slot="afterList">
                                                            <div v-observe-visibility="reachedEndOfSalespersonList" />
                                                        </template>
                                                    </multiselect>
                                                    <span class="mt-5 ml-1">
                                                        <span class="mt-3"><i class="icon text-orange icon-check-circle"></i></span>
                                                    </span>
                                                </div>
                                                <div class="text-right pr-10">
                                                    <span class="float-left text-danger mb-3" v-show="errors.has('sales_person')">Salesperson Name is Required</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-5">
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div class="w-100" :class="{'pointer-event':$route.params.id != 'new' && deal_type == 'contacts'}">
                                                <span class="input-label">
                                                    Contact Name
                                                    <sup class="fs-14 pl-1" >
                                                        <el-tooltip class="item" effect="dark" content="Either Contact or Customer to be selected to create a deal" placement="top">
                                                            <i class="icon icon-information text-secondary fs-18"></i>
                                                        </el-tooltip>
                                                    </sup>
                                                </span>
                                                <div class="d-flex align-items-center">
                                                    <multiselect disabled @change="territoryData(contact_name.territory)" v-if="$route.params.id == 'new' || ($route.params.id != 'new' && deal_type == 'customers')" @search-change="searchContactNameDebouncer()" @open="fetchContactNameDebouncer" @select="contactNameSelected" :loading="contact_name_loading" class="diginew-multiselect new-align-multi deals-multiselect no-default-icon down-arrow mt-2 cc"   :searchable="true" :options="contacts" name="contact_name" label="full_name" v-model="contact_name" placeholder="Select Contact Name">
                                                        <!--<template slot="noOptions">
                                                            <div class="text-secondary text-center fw-600">Contacts not found</div>
                                                        </template>-->
                                                        <template slot="noResult">
                                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                                        </template>
                                                        <template slot="afterList">
                                                            <div v-observe-visibility="reachedEndOfContactName" />
                                                        </template>
                                                    </multiselect>
                                                    <multiselect @change="territoryData(contact_name.territory_id_id)" v-if="$route.params.id != 'new' && deal_type == 'contacts'" @search-change="searchContactNameDebouncer()" @open="fetchContactNameDebouncer" :loading="contact_name_loading" class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-2 dd" :searchable="true" :options="contacts" name="contact_name" label="full_name" v-model="contact_name" placeholder="Select Contact Name">
                                                    </multiselect>
                                                    <span class="mt-4 ml-1" v-if="$route.params.id != 'new' && deal_type == 'contacts'">
                                                        <span class="mt-3"><i class="icon text-green icon-check-circle"></i></span>
                                                    </span>
                                                </div>
                                                <!-- <div class="text-right pr-10">
                                                    <span class="float-left text-danger mb-3" v-show="errors.has('contact_name')">{{errors.first('contact_name')}}</span>
                                                </div> -->
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div class="w-100" :class="{'pointer-event':$route.params.id != 'new' && deal_type == 'customers'}">
                                                <span class="input-label">
                                                    Customer Name
                                                    <sup class="fs-14 pl-1" >
                                                        <el-tooltip class="item" effect="dark" content="Either Customer or Contact to be selected to create a deal" placement="top">
                                                            <i class="icon icon-information text-secondary fs-18"></i>
                                                        </el-tooltip>
                                                    </sup>
                                                </span>
                                                <div class="d-flex align-items-center">
                                                    <multiselect disabled @search-change="searchCompanyDebouncer()" @change="territoryData(companies.territory)" @open="fetchCompanyDebouncer()" @close="customerNameSelected(company_name)" :loading="companies_loading" class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-2" label="customer_name"  :searchable="true" :options="companies" name="company_name" v-model="company_name" placeholder="Select Customer Name">
                                                        <!--<template slot="noOptions">
                                                            <div class="text-secondary text-center fw-600">Companies not found</div>
                                                        </template>-->
                                                        <template slot="noResult">
                                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                                        </template>
                                                        <template slot="afterList">
                                                            <div v-observe-visibility="reachedEndOfCompanies" />
                                                        </template>
                                                    </multiselect>
                                                    <span class="mt-4 ml-1" v-if="($route.params.id != 'new' && deal_type == 'customers') || ($route.params.id != 'new' && deal_type == 'contacts' && company_name.customer_name !== '')">
                                                        <span class="mt-3"><i class="icon text-green icon-check-circle"></i></span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div class="w-100">
                                                <span class="input-label">Priority<sup class="fs-14 pl-1 text-danger">*</sup></span>
                                                <multiselect class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-2" ref="priority_multiselectInput"  v-validate="'required'" :searchable="true" :options="priorities" name="priority_multiselect" v-model="priority" placeholder="Select Priority">
                                                    <template slot="noOptions">
                                                        <div class="text-secondary text-center fw-600">Priority not found</div>
                                                    </template>
                                                    <template slot="noResult">
                                                        <div class="text-secondary text-center fw-600">No Results Found</div>
                                                    </template>
                                                </multiselect>
                                            </div>
                                            <div class="text-right pr-10">
                                                <span class="float-left text-danger mb-3" v-show="errors.has('priority_multiselect')">Priority is required</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-5">
                                        <!-- <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div class="w-100">
                                                <span class="input-label">Forecast Category<sup class="fs-14 pl-1 text-danger">*</sup></span>
                                                <multiselect class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-2" v-validate="'required'" :searchable="true" :options="forecast_options" name="forecast" v-model="forecast"  :loading="load_forecast_type" @search-change="searchForecastType" placeholder="Select Forecast Category">
                                                    <div class="add-vendor fw-500">
                                                        Add Forecast Type
                                                        <span class="text-secondary fw-500">'{{add_forecast_type}}'</span>
                                                        <i class="icon icon-plus ml-2 mt-1 float-right text-secondary"></i>
                                                    </div>
                                                    <template slot="noOptions">
                                                        <div class="text-secondary text-center fw-600">Forecast Category not found</div>
                                                    </template>
                                                    <template slot="noResult">
                                                        <div class="text-secondary text-center fw-600">No Results Found</div>
                                                    </template>
                                                </multiselect>
                                                <div class="text-right pr-10">
                                                    <span class="float-left text-danger mb-3" v-show="errors.has('forecast')">{{errors.first('forecast')}}</span>
                                                </div>
                                            </div>
                                        </div> -->
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div class="w-100">
                                                <span class="input-label">Expected Close Date<sup class="fs-14 pl-1 text-danger">*</sup></span>
                                                <div class="d-flex align-items-center mt-2">
                                                    <date-picker v-model="expected_date" v-validate="'required'" name="expected_date" class="meetinfdatetime calendar-edit-per calendar-edit-per-margin deal-date mx-left mr-1"  value-type="format" type="date" format="YYYY-MM-DD" lang="en" :clearable="false"  confirm confirm-text="APPLY"></date-picker>
                                                </div>
                                                <div class="text-right pr-10">
                                                    <span class="float-left text-danger mb-3" v-show="errors.has('expected_date')">Expected Close Date is Required</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div class="w-100">
                                                <span class="input-label">Deal Pipeline<sup class="fs-14 pl-1 text-danger">*</sup></span>
                                                <div class="d-flex align-content-center">
                                                    <multiselect :loading="pipeline_loading" class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-2" ref="deal_pipeline_multiselectInput" v-validate="'required'"  label="pipeline_name" :searchable="true" :options="deals_pipeline_options" name="deal_pipeline_multiselect" @search-change="searchPipelines" v-model="deal_pipeline" placeholder="Select Deal Pipeline">
                                                        <template slot="noOptions">
                                                            <div class="text-secondary text-center fw-600">Deal Pipelines not found</div>
                                                        </template>
                                                        <template slot="noResult">
                                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                                        </template>
                                                        <template slot="afterList">
                                                            <div v-observe-visibility="reachedEndOfPipelines" />
                                                        </template>
                                                    </multiselect>
                                                    <span class="pointer" @click="changeView()">
                                                        <el-tooltip class="item" effect="dark" content="The value is auto-filled and configurable in Settings. Click here to go to Settings" placement="bottom">
                                                            <img src="/static/images/images-new-theme/icons/settings-new-right.svg" class="ml-2 mt-4" style="width:20px" alt="">
                                                        </el-tooltip>
                                                    </span>
                                                </div>
                                                <div class="text-right pr-10">
                                                    <span class="float-left text-danger mb-3" v-show="errors.has('deal_pipeline_multiselect')">{{errors.first('deal_pipeline_multiselect')}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div class="w-100">
                                                <span class="input-label">Territory</span>
                                                <div class="d-flex align-content-center mt-2">
                                                    <input type="text" name="territory" disabled class="input-field input-width"  v-model="territory" placeholder="Select Contact or Customer" />
                                                    <span class="mt-4 ml-1">
                                                        <span class="mt-3"><i class="icon text-green icon-check-circle"></i></span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Permission Section -->
                            <div class="create-company-container w-100 mt-8">
                                <div class="px-17" >
                                    <div class="create-company-header d-flex align-items-center justify-content-between">
                                        <span class="fs-14 text-white ml-1 fw-500">Permissions</span>
                                        <div>
                                            <span class="collapse-addon pointer"
                                                @click="expandPermission()">
                                                <i v-if="showPermissions"
                                                    class="icon-chevron-double-up text-white" style="line-height: 1 !important;"></i>
                                                <i v-else
                                                    class="icon-chevron-double-down text-white" style="line-height: 1 !important;"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div v-show="showPermissions == true" class="pl-14 pr-17">
                                    <div class="row mt-3">
                                        <div class="col-lg-12 col-md-12 col-sm-12 pr-0">
                                            <div class="form-group pt-0">
                                                <div class="d-flex align-items-center my-3">
                                                    <span class="text-secondary whiteSpace fs-14 fw-600 ml-3">Access To :</span>
                                                    <div class="d-flex justify-content-between ml-4 align-items-center">
                                                        <div class="form-check form-check-inline mb-1 ">
                                                            <label class="form-check-label check-label-dc">
                                                                <input class="form-check-input"
                                                                    type="radio"
                                                                    value="private"
                                                                    name="email_individual"
                                                                    @change="changePermission('private')"
                                                                    v-model="general_access" />
                                                                <span class="radio-icon"></span>
                                                            </label>
                                                        </div>
                                                        <span class="text-secondary fs-14 fw-600 mr-7">Individual and Team</span>
                                                    </div>
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        <div
                                                            class="form-check form-check-inline mr-2 mb-1  ">
                                                            <label
                                                                class="form-check-label check-label-dc">
                                                                <input class="form-check-input"
                                                                    type="radio"
                                                                    value="public"
                                                                    name="email_all"
                                                                    @change="changePermission('public')"
                                                                    v-model="general_access" />
                                                                <span class="radio-icon"></span>
                                                            </label>
                                                        </div>
                                                        <span class="text-secondary fs-14 fw-600">All
                                                            <sup class="fs-14 ml-02 mandatory">
                                                                <el-tooltip class="item" effect="dark"
                                                                    content="Visible to everyone within company"
                                                                    placement="bottom"
                                                                    style="word-break: break-word;">
                                                                    <i class="icon-information text-secondary fs-18 pl-1"></i>
                                                                </el-tooltip>
                                                            </sup>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center my-3" >
                                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                                        <span class="text-secondary whiteSpace fs-14 fw-600">Individual</span>
                                                        <multiselect class="diginew-multiselect-longshort greyblack no-default-icon mt-3"
                                                            :disabled="general_access == 'public'"
                                                            name="email_recipients"
                                                            @search-change="searchIndividuals"
                                                            @select="selectIndividual($event)"
                                                            @remove="customIndividualRemove($event)"
                                                            :loading="individual_loadig"
                                                            v-model="add_permission.individual"
                                                            :searchable="true" :block-keys="['Tab']"
                                                            placeholder="Add Members"
                                                            :options="individualMemberOptions"
                                                            :multiple="true"
                                                            :close-on-select="true"
                                                            :show-labels="false"
                                                            :clear-on-select="true"
                                                            :hide-selected="true"
                                                            label="email"
                                                            track-by="email">
                                                            <template slot="tag"
                                                                slot-scope="{ option, remove }">
                                                                <span class="custom__tag">
                                                                    <span>{{ option.email }}</span>
                                                                    <span class="custom__remove mt-1"
                                                                        @click="remove(option)">
                                                                        <i class="icon-close iconsize-16 defaultDarkBlue"></i>
                                                                    </span>
                                                                </span>
                                                            </template>
                                                            <template slot="afterList">
                                                                <div
                                                                    v-observe-visibility="reachedEndOfIndividuals" />
                                                            </template>
                                                            <template slot="noOptions">
                                                                <div
                                                                    class="text-secondary text-center fw-600">
                                                                    List is Empty</div>
                                                            </template>
                                                            <template slot="noResult">
                                                                <div
                                                                    class="text-secondary text-center fw-600">
                                                                    No Results Found</div>
                                                            </template>
                                                        </multiselect>
                                                    </div>
                                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                                        <span class="text-secondary whiteSpace fs-14 fw-600">Team</span>
                                                        <multiselect class="diginew-multiselect-longshort greyblack no-default-icon mt-3"
                                                            :disabled="general_access == 'public'"
                                                            name="email_recipients"
                                                            @search-change="searchTeam"
                                                            @select="selectTeam($event)"
                                                            @remove="customTeamRemove($event)"
                                                            :loading="team_loadig"
                                                            v-model="add_permission.team"
                                                            :searchable="true" :block-keys="['Tab']"
                                                            placeholder="Add Team"
                                                            :options="teamOptions"
                                                            :multiple="true"
                                                            :close-on-select="true"
                                                            :show-labels="false"
                                                            :clear-on-select="true"
                                                            :hide-selected="true"
                                                            label="email_id"
                                                            track-by="email_id">
                                                            <template slot="tag"
                                                                slot-scope="{ option, remove }">
                                                                <span class="custom__tag">
                                                                    <span>{{ option.email_id }}</span>
                                                                    <span class="custom__remove mt-1"
                                                                        @click="remove(option)">
                                                                        <i class="icon-close iconsize-16 defaultDarkBlue"></i>
                                                                    </span>
                                                                </span>
                                                            </template>
                                                            <template slot="afterList">
                                                                <div
                                                                    v-observe-visibility="reachedEndOfTeam" />
                                                            </template>
                                                            <template slot="noOptions">
                                                                <div
                                                                    class="text-secondary text-center fw-600">
                                                                    List is Empty</div>
                                                            </template>
                                                            <template slot="noResult">
                                                                <div
                                                                    class="text-secondary text-center fw-600">
                                                                    No Results Found</div>
                                                            </template>
                                                        </multiselect>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <div class="row">
                                            <div class="btn-align mt-2 w-100" style="justify-content:flex-end;">
                                                <button v-if="this.add_permission.team == '' && this.add_permission.individual == ''" type="button" class="reset-btn mt-4" style="box-shadow: none;background-color: #ccc !important;border: 1px solid #ccc !important;cursor: no-drop !important;" disabled>
                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/reset.svg" alt="" style="margin-right:2px;">
                                                    Reset
                                                </button>
                                                <button v-else type="button" class="reset-btn mt-4" style="box-shadow: none;" @click="resetPermissions()">
                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/reset.svg" alt="" style="margin-right:2px;">
                                                    Reset
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Products Section -->
                            <div class="create-company-container w-100 mt-8">
                                <div class="px-17" >
                                    <div class="create-company-header d-flex align-items-center justify-content-between">
                                        <span class="fs-14 text-white ml-1 fw-500">Products</span>
                                    </div>
                                </div>
                                <div v-if="show_product" class="pl-14 pr-17">
                                    <div v-for="(product, product_index) in products" :key="product_index" class="p-3 round-4px mb-3">
                                        <div class="row mt-4">
                                            <div class="col-lg-8 col-md-8 col-sm-12">
                                                <div class="w-100">
                                                    <span class="input-label">Products<sup class="fs-14 pl-1 text-danger">*</sup></span>
                                                    <multiselect
                                                        class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-2"
                                                        placeholder="Select Product"
                                                        label="name" open-direction="bottom"
                                                        v-model="product.product_name" @open="resetData('name')"
                                                        :options="products_options" track-by="_id" @remove="customRemoveProduct"
                                                        :multiple="true" :searchable="true" :internal-search="true"
                                                        :clear-on-select="false" :close-on-select="true" :options-limit="3000"
                                                        :max-height="200" :show-no-results="true" :hide-selected="false"
                                                        :blockKeys="['Delete']" :limit="1" :limit-text="limitProduct" :loading="products_loading" @search-change="searchProuctName"
                                                    >
                                                        <template slot="option" slot-scope="props" class="d-flex">
                                                            {{ props.option.name }}
                                                        </template>
                                                        <template slot="afterList">
                                                            <div v-observe-visibility="reachedEndOfProductName" />
                                                        </template>
                                                        <template slot="noOptions">
                                                            <div class="text-secondary text-center fw-600">Products Not Found</div>
                                                        </template>
                                                        <template slot="noResult">
                                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                                        </template>
                                                    </multiselect>
                                                        <!-- <multiselect class="diginew-multiselect deal-product-multi new-align-multi no-default-icon down-arrow mt-2"
                                                        :loading="products_loading" @search-change="searchProducts" v-validate="'required'" track-by="id"
                                                        :searchable="true" data-vv-as="Product" :options="products_options" :name="'products'+product_index"
                                                        label="product_name" v-model="product.product_name" placeholder="Select Product" @remove="customRemoveProduct"
                                                        :clear-on-select="true" :close-on-select="true" :multiple="true" :blockKeys="['Delete']"
                                                        :limit="4" :limit-text="limitProductsTo">
                                                            <template slot="tag" slot-scope="{ option }">
                                                                <span class="custom__tag">
                                                                    <span class="filterSelectedName">{{ option.product_name }}</span>
                                                                    <span class="custom__remove pointer" @click="removeProduct(option)">
                                                                        <i class="icon icon-close fs-62 text-white"></i>
                                                                    </span>
                                                                </span>
                                                            </template>
                                                            <template slot="noOptions">
                                                                <div class="text-secondary text-center fw-600">Products not found</div>
                                                            </template>
                                                            <template slot="noResult">
                                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                                            </template>
                                                            <template slot="afterList">
                                                                <div v-observe-visibility="reachedEndOfProducts" />
                                                            </template>
                                                        </multiselect> -->
                                                    <div class="text-right pr-10">
                                                        <span class="float-left text-danger mb-3" v-show="errors.has('products' +product_index)">{{errors.first('products'+product_index)}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-12 pr-0">
                                                <div class="w-100 pl-3">
                                                    <span class="input-label fs-14 fw-600 whiteSpace">Total Transaction Value</span>
                                                    <div class="d-flex align-content-center">
                                                        <!-- <el-select name="transition" :disabled="true" class="mt-2 select-width symbol-color" v-model="transition_format" :popper-append-to-body="false">
                                                            <el-option v-for="(item, tv_index) in transition_format" :key="tv_index"  :label="item" :value="item"></el-option>
                                                        </el-select> -->
                                                        <input type="text" name="transition" :disabled="true" class="mt-2 mr-2 input-field input-width" readonly v-model="transition_format" style="width: 50px !important;text-align: center;"/>
                                                        <input type="text" :readonly="true" class="input-field input-width mt-2 ml-2" v-model="total_transition" name="total_transition" />
                                                        <span class="mt-5 ml-1"><i class="icon text-green icon-check-circle"></i></span>
                                                    </div>
                                                    <!-- <div class="text-right pr-10">
                                                        <span class="float-left text-danger mb-3" v-show="errors.has('total_transition')">{{errors.first('total_transition')}}</span>
                                                    </div> -->
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="product.product_name.length != 0" class="row mt-5" style="overflow: auto !important;">
                                            <table class="team-list-table w-100">
                                                <thead>
                                                    <tr>
                                                        <th style="width: 2%;">S.NO</th>
                                                        <th style="width: 15%;">PRODUCT</th>
                                                        <th style="width: 14%;">TEMPLATE INFO</th>
                                                        <th style="width: 21%;">QUANTITY</th>
                                                        <th style="width: 28%;">TRANSACTION VALUE PER UNIT ({{transition_format}})</th>
                                                        <th style="width: 20%;">TRANSACTION VALUE ({{transition_format}})<span class="mt-5 ml-1"><i class="icon text-white icon-check-circle"></i></span></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(sub_products, sub_products_index) in product.product_name" :key="sub_products_index">
                                                        <td class="text-center">{{sub_products_index+1}}</td>
                                                        <td class="prod-name-col text-truncate" :title="sub_products.name">{{sub_products.name}}</td>
                                                        <td class="prod-name-col text-truncate" style="color: #00448b;">
                                                            <button @click="openSalesData(sub_products)" class="btn btn-secondary text-capitalize" style="border-radius: 4px !important;">Sales Info</button>
                                                            <!-- <div class="text-danger" id="addressCheck"></div> -->
                                                            <!-- <span class="" @click="getProductData(sub_products, sub_products_index, product_index)">
                                                                <el-popover
                                                                    placement="bottom"
                                                                    trigger="click">
                                                                    <div class="fs-14 fw-600">
                                                                        {{sub_products.name}} Info:
                                                                    </div>
                                                                    <div class="fs-12 fw-400 pt-1" v-if="template_loader">
                                                                        <hollow-dots-spinner style="position: absolute;margin: 0;top: 36px;left:10px;display: flex;justify-content: center;width: 80% !important;"  :animation-duration="800" :dot-size="8" :dots-num="3" :color="'#00448b'" />
                                                                    </div>
                                                                    <div v-else class="fs-12 fw-400 pt-1" v-for="(template, template_index) in sub_products.template_details" :key="template_index">
                                                                        <div class="fs-12 fw-400" style="padding-top: 2px !important;"><span style="width: 120px;">{{template.field_name}}</span>: <span v-if="template.field_type == 'checkbox'" style="padding-left: 11px;"><span v-for="(value, value_index) in template.value" :key="value_index">{{value}}&nbsp;</span></span><span v-else style="padding-left: 11px;">{{template.value}} </span>
                                                                        </div>
                                                                    </div>
                                                                    <el-button slot="reference" class="text-secondary fw-500 fs-14" style="margin-top: -4px;">
                                                                        <span>View Info
                                                                            <i class="icon-information text-secondary" style="font-size: 20px;"></i>
                                                                        </span>
                                                                    </el-button>
                                                                </el-popover>
                                                            </span> -->
                                                        </td>
                                                        <td>
                                                            <div class="w-100">
                                                                <div class="d-flex align-content-center mt-2">
                                                                    <input type="text" v-on:keypress="isNumberExcludeDot($event)" :name="'quantitys'+sub_products_index" data-vv-as="Quantity"  v-validate="{required:true,max:5}" :maxLength="5" @input="totalTransition(sub_products)" class="input-field input-width" v-model.number="sub_products.quantitys" placeholder="Enter Quantity" />
                                                                </div>
                                                                <div class="text-right pr-10">
                                                                    <span class="float-left text-danger mb-3" v-show="errors.has('quantitys'+sub_products_index)">{{errors.first('quantitys'+sub_products_index)}}</span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="w-100" style="position: relative;">
                                                                <div class="d-flex align-content-center">
                                                                    <!-- <el-select  name="transition" :disabled="true" class="mt-2 mr-2 select-width symbol-color" v-model="transition_format" :popper-append-to-body="false">
                                                                        <el-option  v-for="(item, option_index) in transition_format" :key="option_index"  :label="item" :value="item"></el-option>
                                                                    </el-select> -->
                                                                    <input type="text" v-on:keypress="isNumber($event)"  data-vv-as="Transaction Value per unit" :maxLength="15" class="input-field input-width mt-2" @input="totalTransition(sub_products)" v-validate="{regex: /^-?\d+(?:\.\d?\d)?$/}" :onfocusout="evaluvateData(sub_products_index)" v-model="sub_products.transition_value_perunit" placeholder="Enter Transaction Value Per Unit" :name="'transition_perunit'+sub_products_index"/>
                                                                </div>
                                                            </div>
                                                            <div v-if="sub_products.transition_value_perunit" class="text-right pr-10" style="position: absolute;">
                                                                <span class="float-left text-danger mb-3" v-if="sub_products.transition_value_perunit != '' && sub_products.transition_value_perunit.endsWith('.')">Invalid Transaction Value Per Unit</span>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="w-100">
                                                                <div class="d-flex align-content-center">
                                                                    <input type="text" data-vv-as="Transaction Value" class="input-field input-width hide-arrow mt-2" placeholder="Enter Transaction Value" readonly v-model.number="sub_products.transition_value" :name="'transition' +sub_products_index"/>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Additional Information Section -->
                            <div class="create-company-container w-100 ">
                                <div class="mt-6 px-17" >
                                    <div class="create-company-header d-flex align-items-center justify-content-between">
                                        <span class="fs-14 text-white ml-1 fw-500">Additional Information</span>
                                    </div>
                                </div>
                                <div class="mt-6 px-17">
                                    <div v-if="additional_info.length == 0 || check_visibility" class="font-weight-bold mt-4 text-center">
                                        No Data Found
                                    </div>
                                    <div class="row mt-3" v-else-if="additional_info.length">
                                        <div class="col-lg-4 col-md-4 col-sm-12" v-for="(info,additional_index) in additional_info" :key="additional_index" v-show="info.visibility">
                                            <div class="form-group contactGroup" v-if="info.field_type == 'input_field'">
                                                <span class="input-label text-capitalize">{{info.field_name.replace('_',' ')}}</span>
                                                <input class="input-field" style="margin-top:3px;" autocomplete="off" v-if="info.data_type == 'text'" :maxLength="info.character_limit" v-model="info.value" type="text" :placeholder="'Enter ' + info.field_name.replace('_',' ')" />
                                                <input class="input-field" style="margin-top:3px;" autocomplete="off" v-else-if="info.data_type == 'decimal'" v-model.number="info.value" v-on:keypress="isNumber($event)" type="text" :placeholder="'Enter ' + info.field_name.replace('_',' ')"/>
                                                <input class="input-field" style="margin-top:3px;" autocomplete="off" v-else-if="info.data_type == 'integer'" v-model.number="info.value"  type="number" :placeholder="'Enter ' + info.field_name.replace('_',' ')" onkeypress='return event.charCode >= 48 && event.charCode <= 57' />
                                                <span class="highlightContact"></span>
                                                <span class="barContact"></span>
                                                <span class="pull-right text-right text-grey font-600 fs-12 pt-1" v-if="info.data_type == 'Text'">{{ info.limit - info.value.length}}/{{info.limit}}</span>
                                            </div>
                                            <div class="form-group" v-if="info.field_type == 'selection_field' && info.data_type == 'radio_button' && info.hasOwnProperty('options')">
                                                <span class="input-label text-capitalize">{{info.field_name.replace('_',' ')}}</span>
                                                <div class="mt-2">
                                                    <el-radio-group v-model="info.value" v-for="(option,index) in info.options" :key="index" class="w-200px">
                                                        <el-radio class="ml-2 pt-2" @change="$forceUpdate()" :label="option.value" :id="option">{{option.value}}</el-radio>
                                                    </el-radio-group>
                                                </div>
                                            </div>
                                            <div class="pt-0" v-if="info.field_type=='input_field' && info.data_type=='date'">
                                                <date-picker class="cal-icon profile-date-picker date-input-customer  calendar-edit-per input-field pt-0 pb-0 pr-0" v-model="info.value" value-type="format" lang="en" type="date" @change="$forceUpdate()" format="YYYY-MM-DD"></date-picker>
                                            </div>
                                            <div class="form-group contactGroup" style="margin-top: 0px;" v-if="info.field_type == 'selection_field' && info.data_type == 'drop_down'">
                                                <span class="input-label text-capitalize">{{info.field_name.replace('_',' ')}}</span>
                                                <multiselect
                                                @close="$forceUpdate()"
                                                v-model="info.value"
                                                class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-1"
                                                id="ajaxnew"
                                                :placeholder="'Select ' + info.field_name.replace('_',' ')"
                                                :options="info.options"
                                                :multiple="false"
                                                :searchable="true"
                                                label="value"
                                                :internal-search="true"
                                                :clear-on-select="false"
                                                :close-on-select="true"
                                                :max-height="200"
                                                :show-no-results="true"
                                                :hide-selected="false"
                                                open-direction="top">
                                                <template slot="noOptions">
                                                    <div class="text-secondary text-center fw-600">Options Not Found</div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                                </multiselect>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Buttons Section -->
                            <div v-if="disableButtonAndDisplayLoader == false" class="d-flex flex-wrap align-items-center justify-content-center mb-4 mt-5">
                                <button class="btn new-cancel-button" @click="cancel()">Cancel</button>
                                <button class="btn new-save-button ml-5" @click="saveDeals()">Save</button>
                            </div>
                            <div v-else class="d-flex flex-wrap align-items-center justify-content-center mb-4 mt-5">
                                <button class="btn btn-new-cancel" style="border: 1px transparent;" disabled>Cancel</button>
                                <button class="btn btn-new-save btn-new-secondary ml-5" style="border: 1px transparent;position: relative;" disabled>Save
                                    <hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 108% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <add-sales-data v-if="add_sales" @saveSalesData="saveSalesData" :product_data="product_data" @hideAddSalesModal="hideAddSalesModal" modal_name="Add-Sales"></add-sales-data>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        <success-message :message="$route.params.id == 'new' || deal_type == 'customers' || deal_type == 'contacts' ? 'Deal Created successfully': 'Deal Updated successfully'" modal_name="success-message" @hideSuccess="hideSuccess"></success-message>
    </div>
</template>
<script>
import teams from '../mixins/teams';
import callreport from '../mixins/callreport';
import deals from '../mixins/deals';
import customers from '../mixins/customer';
import contacts from "../mixins/contacts.js";
import products from "../mixins/products.js";
import settings from "../mixins/settings.js";
import { EventBus } from '../eventBus/nav-bar-event'
import { SweetModal } from 'sweet-modal-vue';
import pipeline_lazy_loading from "../mixins/pipeline_lazyloading";
const SuccessMessage = () => import("../SuccessMessage");
import { HollowDotsSpinner } from "epic-spinners";
import AddSalesData from "./AddSaleData"
import schedule from "../mixins/scheduleMeeting.js"
import moment from 'moment';
import { debounce } from 'lodash'
import _ from 'lodash'
export default {
    data(){
        return {
            disableButtonAndDisplayLoader: false,
            temp_salesperson_name: [],
            temp_salesperson_ids: [],
            salesperson_loading: false,
            ajaxCallInProgress: false,
            // load_forecast_type:false,
            add_company_address: false,
            show_deals_details: true,
            addNewProduct:false,
            show_product: true,
            selected_lead: "Individual",
            selected_status: null,
            deal_name: "",
            companies: [],
            priorities: ['High','Low','Medium'],
            priority: null,
            addNewProductSection:false,
            branches: [],
            owners: [],
            owner_name: "",
            salesperson_name: [],
            salesperson_name_options: [],
            territory:"",
            // add_forecast_type:'',
            // forecast_options: ["Best Case" , "Pipeline" , "Commit"],
            products_options: [],
            expected_date :moment(new Date().toUTCString()).format("YYYY-MM-DD"),
            // forecast: null,
            contact_mobile_number: {
                phone_number: "",
                dial_code: "",
                country_code: "",
                phone_type: ""
            },
            // expected_revenue:'',
            transition_symbol: null,
            deal_pipeline_options: [],
            deal_pipeline: null,
            contact_name:"",
            company_name:"",
            date_iso: false,
            date: new Date(),
            formatted_date: moment(new Date().toUTCString()).format("YYYY-MM-DD"),
            temp_forecast: [],
            forecast_count: 0,
            forecast_scrollable: false,
            forecast_visible: false,
            skip: 0,
            limit: 10,
            success_deals: false,
            success_msg: "",
            warning_msg: "",
            deal_id: null,
            interested_product_name: '',
            products: [{
                product_id: "",
                quantitys: 0,
                product_name: [],
                transition_value_perunit: 0,
                transition_value: 0,
                template_fields: []
            }],
            temp_product_array : [{
                product_id: "",
                quantitys: null,
                product_name: null,
                transition_value_perunit: null,
                transition_value: null,
                template_fields: []
            }],
            contacts: [],
            transition_format : "$",
            contact_name_count: 0,
            contact_name_loading:false,
            contact_name_scrollable :false,
            contact_name_visible: false,
            temp_contacts: [],
            salesperson_visible: false,
            salesperson_scrollable :false,
            salesperson_count: 0,
            temp_salesperson: [],
            products_count: 0,
            products_loading:false,
            products_scrollable :false,
            products_visible: false,
            temp_products: [],
            companies_loading: false,
            temp_companies: [],
            companies_count: 0,
            companies_scrollable: false,
            companies_visible: false,
            deal_type: null,
            temp_selected_products: [],
            total_transition: 0,
            customer_auto_fill: false,
            customer_id: '',
            is_customer_selected: false,
            additional_info: [],
            check_visibility: false,
            addedProduct: [],
            product_already_added: false,
            territory:'',
            territory_id: '',
            add_permission:{
                individual:[],
                team:[]
            },
            permissions:{
                individual_permission_list:[],
                team_permission_list:[]
            },
            showPermissions: true,
            general_access:"private",
            user_ids_ind: [],
            individualMemberOptions: [],
            individual_visible: false,
            temp_individual_member_options: 0,
            individual_loadig: false,
            individual_scrollable: false,
            individual_count: 0,
            user_ids_team:[],
            teamOptions: [],
            team_visible: false,
            temp_team_options: 0,
            team_loadig: false,
            team_scrollable: false,
            team_count: 0,
            from_lead: false,
            template_details:{},
            template_loader: false,
            add_product: false,
            add_sales: false,
            product_data: [],
            template_data: [],
            meeting_id: "",
            meetingLoader: false,
            meeting_details: []
        }
    },
    mixins:[deals,contacts,pipeline_lazy_loading,customers,products,settings,callreport,teams, schedule],
    components:{
        SweetModal,
        SuccessMessage,
        HollowDotsSpinner,
        AddSalesData
    },
    methods:{
        saveSalesData(value){
            this.template_data = value
            // this.temp_selected_products = []
        },
        hideAddSalesModal(){
            this.add_sales = false
        },
        openSalesData(product){
            this.product_data = product
            this.add_sales = true
            setTimeout(() => {
                this.$modal.show("Add-Sales");
            }, 500);
        },
        async getProductData(data, index, pr_index){
            this.template_loader = true
            let params = {
                _id: data._id,
                edit: true
            }
            let response = await this.GetProductByID(params)
            let sales_template_details_data = response.response.result
            let sales_data_details = sales_template_details_data.sales_template_details.fields
            this.products[pr_index].product_name[index].template_details = sales_data_details
            this.template_loader = false
        },
        async getMeetingData(){
            this.meetingLoader = true
            let params = {
                id: this.meeting_id
            }
            let response = await this.getScheduleMeetingById(params)
            this.meeting_details = response.response
            this.company_name = this.meeting_details.customer_details
            this.customer_id = this.company_name.id
            this.meetingLoader = false
        },
        limitProduct(count) {
			return `+ ${count} more`
        },
        resetData(type){
            this.selected_field = type
            this.products_options = [];
            this.products_count = 0;
        },
        async searchProuctNameDebouncer(search){
            this.products_loading = true
            this.products_count = 0
            let params = {
                skip: this.skip,
                limit: 10,
                search_key: search,
                sort_key: "name",
                sort_value: 1,
                category_ids:[],
                sub_category_ids:[],
                product_type_ids:[],
                product_ids:[],
                brand_ids:[],
                outlet_ids:[],
                status:[],  
                visibility:"Manufacturing"
            }
            let response = await this.ProductsList(params)
            this.products_options = response.response.result
            
            this.products_count = this.products_options.length
            this.products_loading = false
        },
        async reachedEndOfProductName(reached){
            if(reached){
                if(this.products_scrollable == false){
                    this.products_loading = true
                    let response = await this.ProductsList({
                        skip: this.products_count,
                        limit: 10,
                        search_key: '',
                        sort_key: "name",
                        sort_value: 1,
                        category_ids:[],
                        sub_category_ids:[],
                        product_type_ids:[],
                        product_ids:[],
                        brand_ids:[],
                        outlet_ids:[],
                        status:[],  
                        visibility:"Manufacturing"
                    } )
                    let temp_products_options = response.response.result.length;
                    if(response.response.filter_data.skip == this.products_count){
                        if(temp_products_options > 0){
                            let tempfiles = response.response.result
                            // tempfiles.forEach(el => {
                            //     if(el[this.selected_field] != '' && el.hasOwnProperty(this.selected_field)){
                            //         this.products_options.push(el)
                            //     }
                            // })
                            // let uniqueArray = this.products_options.filter((value, index_dd) => {
                            //     const _value = value[this.selected_field];
                            //     return index_dd === this.products_options.findIndex(obj => {
                            //         return obj[this.selected_field] === _value;
                            //     });
                            // });
                            this.products_options = tempfiles
                            this.products_count += response.response.result.length;
                            this.products_loading = false
                        } else {
                            this.products_scrollable = true
                            this.products_loading = false
                        }
                        this.products_scrollable = false
                    }
                }
            }
        },
        //Delete Individual permissions
        customIndividualRemove(data){
            this.permissions.individual_permission_list.forEach((el,del_individual_index) => {
                if(el.id == data.id){
                    this.permissions.individual_permission_list.splice(del_individual_index,1)
                } else if(el.id == data.user_id){
                    this.permissions.individual_permission_list.splice(del_individual_index,1)
                }
            })
        },
        //Delete Team Permissions
        customTeamRemove(data){
            this.permissions.team_permission_list.forEach((el,del_team_index) => {
                if(data.id == el.id){
                    this.permissions.team_permission_list.splice(del_team_index,1)
                }
            })
        },
        //Resets Individual and Team Permissions
        resetPermissions(){
            this.add_permission.individual = [];
            this.add_permission.team = [];
            this.permissions.individual_permission_list = [],
            this.permissions.team_permission_list = []
        },
        expandPermission() {
            if (!this.showPermissions) {
                this.showPermissions = true;
            } else {
                this.showPermissions = false;
            }
        },
        changePermission(selected_type) {
            if(selected_type == 'public'){
                this.add_permission.individual = []
                this.add_permission.team = [],
                this.permissions.individual_permission_list = [],
                this.permissions.team_permission_list = []
            }
        },
        selectIndividual(data){
            this.permissions.individual_permission_list.push({
                email_id: data.email,
                id: data.user_id,
                name: data.full_name
            })
        },
        selectTeam(data){
            this.permissions.team_permission_list.push({
                email_id: data.email_id,
                id: data.id,
                name: data.name
            })
        },
        // API call to get individual permissions members
        async searchIndividualsDebounce(key) {
            try{
                let params = {
                    limit: 10,
                    skip: 0,
                    search_key: key,
                    exclude: this.user_ids_ind
                };
                let response = await this.getMembersData(params)
                this.individualMemberOptions = response.response
                this.individual_count = this.temp_individual_member_options
                this.individual_scrollable = false
            }
            catch(reason){
            }
        },
        // Lazy loading for individual permissions members API call
        async reachedEndOfIndividuals(reached){
            this.individual_visible = reached
            if (reached) {
                if (this.individual_scrollable == false) {
                    this.individual_loadig = true
                    let params ={
                        skip:this.individual_count,
                        limit:10,
                        search_key:"",
                        exclude: this.user_ids_ind
                    }
                    let response = await this.getMembersData(params)
                    this.temp_individual_member_options = response.response.length;
                    if (response.skip == this.individual_count) {
                        if (this.temp_individual_member_options > 0) {
                            let tempFiles = response.response;
                            tempFiles.forEach(el => {
                                this.individualMemberOptions.push(el);
                            });
                            this.individual_count += response.response.length;
                            this.individual_loadig = false
                        } else {
                            this.individual_scrollable = true
                            this.individual_loadig = false
                        }
                    }
                    this.individual_loadig = false
                }
            }
        },
        // API call to get Teams permissions list
        async searchTeamDeounce(key) {
            try{
                let params = {
                    limit: 10,
                    skip: 0,
                    search_key: key,
                    filter_json:{
                        exclude: this.user_ids_team
                    }
                };
                let response = await this.getPermissionList(params)
                this.teamOptions = response.response
                this.team_count = this.temp_team_options
                this.team_scrollable = false
            }
            catch(reason){
            }
        },
        // Lazy loading Teams permissions list API call
        async reachedEndOfTeam(reached){
            this.team_visible = reached
            if (reached) {
                if (this.team_scrollable == false) {
                    this.team_loadig = true
                    let params ={
                        skip:this.team_count,
                        limit:10,
                        search_key:"",
                        filter_json:{
                            exclude: this.user_ids_team
                        }
                    }
                    let response = await this.getPermissionList(params)
                    this.temp_team_options = response.response.length;
                    if (response.skip == this.team_count) {
                        if (this.temp_team_options > 0) {
                            let tempFiles = response.response;
                            tempFiles.forEach(el => {
                                this.teamOptions.push(el);
                            });
                            this.team_count += response.response.length;
                            this.team_loadig = false
                        } else {
                            this.team_scrollable = true
                            this.team_loadig = false
                        }
                    }
                    this.team_loadig = false
                }
            }
        },
        //API call to get sales persons list data
        async loadSalespersonListDebouncer(){
            this.salesperson_loading = true;
            let params = {
                    skip: 0,
                    limit: 10,
                    search_key: "",
                    sort_key:'name',
                    sort_value:1
            }
            let response = await this.getSalespersonsList(params);
            this.salesperson_name_options = response.response
            this.temp_salesperson_name = this.salesperson_name_options
            this.salesperson_count = this.salesperson_name_options.length
            this.salesperson_loading = false;
        },
        //Lazy loading for sales persons list data API call
        async reachedEndOfSalespersonList(reached) {
            this.salesperson_visible = reached
            if (reached) {
                if (this.salesperson_scrollable == false) {
                    this.salesperson_loading = true
                    let params = {
                        skip: this.salesperson_count,
                        limit: 10,
                        search_key: "",
                        sort_key:'name',
                        sort_value:1
                    }
                    let response = await this.getSalespersonsList(params);
                    this.temp_salesperson = response.response.length;
                    if (response.skip == this.salesperson_count) {
                        if (this.temp_salesperson > 0) {
                            let tempFiles = response.response;
                            tempFiles.forEach(el => {
                                this.salesperson_name_options.push(el);
                            });
                            this.salesperson_count += response.response.length;
                            this.salesperson_loading = false
                        } else {
                            this.salesperson_scrollable = true
                            this.salesperson_loading = false
                        }
                    }
                    this.salesperson_loading = false
                }
            }
        },
        limitSalespersonsTo(count){
            return `+ ${count} more`
        },
        limitProductsTo(count){
            return `+ ${count} more`
        },
        //To remove sales person
        removeSalesperson(option){
            if(this.salesperson_name == option){
                this.salesperson_name = [];
            } else{
                this.salesperson_name.forEach((el,index)=>{
                    if(el == option){
                        this.salesperson_name.splice(index,1)
                    }
                })
            }
        },
        //To remove product
        removeProduct(option) {
            this.products.forEach((el, index) => {
                el.product_name.forEach((product, product_index) =>{
                    if (product.product_id == option.product_id) {
                        el.product_name.splice(product_index, 1)
                    }
                })
            })
            let prod_option_index = this.products_options.findIndex(x => x.id === option.id);
            this.products_options[prod_option_index].quantitys = null
            this.products_options[prod_option_index].transition_value_perunit = null
            this.products_options[prod_option_index].transition_value = 0
            this.$forceUpdate()
            this.products.forEach((el, index) => {
                this.totalTransition(el.product_name);
            })
        },
        customRemoveProduct(option) {
            let prod_option_index = this.products_options.findIndex(x => x._id === option._id);
            this.products_options[prod_option_index].quantitys = null
            this.products_options[prod_option_index].transition_value_perunit = null
            this.products_options[prod_option_index].transition_value = 0
            this.$forceUpdate()
            this.products.forEach((el, index) => {
                this.totalTransition(el.product_name);
            })
        },
         //Calculates total transaction values
        evaluvateData(index){
            setTimeout(() => {
                this.products.forEach((el) => {
                    el.product_name.forEach((el_product, el_product_index ) => {
                        if(index === el_product_index){
                            if(el_product.transition_value_perunit){
                                if(el_product.transition_value_perunit.startsWith(".")){
                                    this.products[0].product_name[index].transition_value_perunit = "0" + el_product.transition_value_perunit
                                }
                            }
                        }
                    })
                })
            }, 500);
            // this.products.forEach((el, el_index) => {
            //     if(index === el_index){
            //         if(amount == 'quoted'){
            //             if(el.price_quoted.startsWith(".")){
            //                 this.products[index].price_quoted = "0" + el.price_quoted
            //             }
            //         } else if(amount === 'inquired'){
            //             if(el.amount_inquired.startsWith(".")){
            //                 this.products[index].amount_inquired = "0" + el.amount_inquired
            //             }
            //         }
            //     }
            // })
        },
        //Validates input data is number or not
        isNumber: (evt) =>  {
            var charCode = (evt.which) ? evt.which : evt.keyCode
            if (charCode > 31 && (charCode < 48 || charCode > 57) && !(charCode == 46 || charCode == 8))
                evt.preventDefault();
            else {
                var index = evt.target.value.indexOf('.');
                if(index == 0){
                    if (charCode > 31 && (charCode < 48 || charCode > 57) && !(charCode == 8)){
                        evt.preventDefault();
                    } else {
                        let number = evt.target.value.split('.')
                        if(number[1].length > 1){
                            evt.preventDefault();
                        }
                    }
                }
                else if (index > 0 && charCode == 46) {
                    evt.preventDefault();
                }
                if (index > 0) {
                    let number = evt.target.value.split('.')
                    if(number[1].length > 1){
                        evt.preventDefault();
                    }
                }
            }
        },
        // isNumber: function(evt, index) {
        //     evt = evt ? evt : window.event
        //     var charCode = evt.which ? evt.which : evt.keyCode
        //     if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        //         evt.preventDefault()
        //     } else {
        //         return true
        //     }
        // },
        isNumberExcludeDot: function(evt, index) {
            evt = evt ? evt : window.event
            var charCode = evt.which ? evt.which : evt.keyCode
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                evt.preventDefault()
            } else {
                return true
            }
        },
        isAlphabet:function(evt,index){
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 65 || charCode > 90) && (charCode < 97 || charCode > 122)) {
                evt.preventDefault()
            }
            return true;
        },
        //change the view and redirect to the settings of deals
        changeView(){
            let contacts = true


            let routeData = this.$router.resolve({name: 'Settings', query: {deals_active:contacts}});
            window.open(routeData.href, '_blank');
        },
        // closeProducts() {
        //     temp_product_array.push(this.products)
        //     // this.products.forEach(x =>{
        //     //     this.addedProduct.forEach(y=>{
        //     //         if(x.product_name.name == y.product_name && x.product_name.product_id == y.product_id){
        //     //             this.product_already_added = true;
        //     //             this.warning_msg = "Product already added"
        //     //             this.$refs.warning_modal.open();
        //     //             setTimeout(() => {
        //     //                 this.$refs.warning_modal.close();
        //     //             }, 10000);
        //     //         } else {
        //     //             this.product_already_added = false;
        //     //         }
        //     //     })
        //     // })
        //     this.products.forEach((x,index ) =>{
        //         if(x.product_name.name == temp_product_array.product_name.name && x.product_name.product_id == temp_product_array.product_name.product_id){
        //             this.product_already_added = true;
        //             this.warning_msg = "Product already added"
        //             this.$refs.warning_modal.open();
        //             setTimeout(() => {
        //                 this.$refs.warning_modal.close();
        //             }, 10000);
        //         } else {
        //             this.product_already_added = false;
        //         }
        //     })
        // },

        //search the forecast type
        /**@params = search_key */
        // searchForecastTypeDebouncer(search_key) {
        //     let letters = /^[A-Za-z]+$/;
        //     if (search_key.match(letters)) {
        //         this.add_forecast_type = search_key;
        //     } else {
        //         this.add_forecast_type = ''
        //     }
        // },
        //hide the success modal
        hideSuccess() {
            this.success_deals = false;
            setTimeout(() => {
                this.$router.push({
                    path: '/deals/dealdetails/' + this.deal_id
                })
            }, 500);
        },
        //show/hide the deal information
        showDealInfo(){
            this.show_deals_details = !this.show_deals_details
        },
        //show/hide the product information
        showProduct(){
            this.show_product = !this.show_product
        },
        //add new product structure
        addNew(index){
            this.products.push({
                product_id: "",
                product_name: null,
                transition_value: null
            });
            this.products.splice(index+1, 0)
        },
        //splice the products structure
        /**@params = index */
        // removeProducts(index) {
        //     this.products.splice(index, 1);
        //     this.total_transition = this.products.reduce(function (result, charges) {
        //         return result + charges.transition_value;
        //     }, 0);
        // },
        //selected the contact name
        /**@params = data */
        contactNameSelected(data) {
            if(data) {
                if(this.is_customer_selected){
                    this.customer_auto_fill = false;
                } else {
                    this.customer_auto_fill = true;
                }
                if(data.customer_id_id == '' || data.customer_id_id == null || data.customer_id_id == undefined) {
                    this.company_name = ''
                } else {
                    this.company_name = {
                        id: data.customer_id_id,
                        customer_name: data.company_name
                    }
                }
                this.territory = data.territory
                this.territory_id = data.territory_id_id
            } else {
                this.company_name = ''
                this.customer_auto_fill = false;
                this.territory = ''
                this.territory_id = ''
            }

        },
        //selected the customer name
        /**@params = data */
        customerNameSelected(data) {
            if(data) {
                this.is_customer_selected = true;
                this.customer_id = data.id;
                this.territory = data.territory ? data.territory : '-';
                this.territory_id = data.territory_id_id
                this.contact_name = '';
            } else {
                this.is_customer_selected = false;
                this.customer_id = '';
                this.territory = '';
                this.territory_id = ''
            }
        },
        //API call to search the contact name
        /**@params = contact_name */
        searchContactNameDebouncer: _.debounce(() => {
            this.searchContactName();
        }, 500),
        async searchContactName(contact_name){
            //this.contacts = [];
            this.contact_name_loading = true
            let response = await this.getBusinessConatactList({
                /**@params = search_key, @params = sort_key, @params = sort_value,@params = limit,@params = skip, @params = filter_json */
                search_key: contact_name,
                skip: 0,
                filter_json: {
                    customer_id: this.customer_id == '' ? '' : [this.customer_id]
                },
                limit: 10,
                sort_key: 'full_name',
                sort_value: 1
            })
            this.contacts = response.response
            this.contact_name_count = this.contacts.length
            this.contact_name_loading = false
            this.contact_name_scrollable = false
        },
        //API call to fetch the contact name
        fetchContactNameDebouncer: _.debounce(() => {
            this.fetchContactName();
        }, 500),
        async fetchContactName(){
            //this.contacts = [];
            this.contact_name_loading = true
            /**@params = search_key, @params = sort_key, @params = sort_value,@params = limit,@params = skip, @params = filter_json */
            let response = await this.getBusinessConatactList({
                search_key: '',
                skip: 0,
                filter_json: {
                    customer_id: this.customer_id == '' ? '' : [this.customer_id]
                },
                limit: 10,
                sort_key: 'full_name',
                sort_value: 1

            })
            this.contacts = response.response
            this.contact_name_count = this.contacts.length
            this.contact_name_loading = false
            this.contact_name_scrollable = false
        },
        //Lazy loading of the contact name
        /**@params = reached */
        async reachedEndOfContactName(reached){
            this.contact_name_visible = reached
            if (reached) {
                if (this.contact_name_scrollable == false) {
                    this.contact_name_loading = true
                    /**@params = search_key, @params = sort_key, @params = sort_value,@params = limit,@params = skip, @params = filter_json */
                    let response = await this.getBusinessConatactList({
                        skip: this.contact_name_count,
                        filter_json: {
                            customer_id: this.customer_id == '' ? '' : [this.customer_id]
                        },
                        limit: 10,
                        search_key: "",
                        sort_key: 'full_name',
                        sort_value: 1
                    })
                    this.temp_contacts = response.response.length;
                    if (response.skip == this.contact_name_count) {
                        if (this.temp_contacts > 0) {
                            let tempFiles = response.response;
                            tempFiles.forEach(el => {
                                this.contacts.push(el);
                            });
                            this.contact_name_count += response.response.length;
                            this.contact_name_loading = false
                        } else {
                            this.contact_name_scrollable = true
                            this.contact_name_loading = false
                        }
                    }
                    this.contact_name_loading = false
                }
            }
        },
        //API call to Search the company
        /**@params = search */
        searchCompanyDebouncer: _.debounce(() => {
            this.searchCompany();
        }, 500),
        async searchCompany(search){
            this.companies = [];
            /**@params = search_key, @params = sort_key, @params = sort_value, @params = status */
            let response = await this.getCustomerList({
                search_key: search,
                status: "active",
                sort_key:'id',
                sort_value: -1
            })
            this.companies = response.response
            this.companies_count = response.response.length;
            this.companies_loading = false
            this.companies_scrollable = false
        },
        //API call to fetch the company details
        fetchCompanyDebouncer: _.debounce(() => {
            this.fetchCompany();
        }, 500),
        async fetchCompany(){
            this.companies = [];
            /**@params = search_key, @params = sort_key, @params = sort_value, @params = status */
            let response = await this.getCustomerList({
                search_key: '',
                status: "active",
                sort_key:'id',
                sort_value: -1

            })
            this.companies = response.response
            this.companies_count = response.response.length;
            this.companies_loading = false
            this.companies_scrollable = false
        },
        //Lazy  loading of the company data
        /**@params = reached */
        async reachedEndOfCompanies(reached){
            this.companies_visible = reached
            if (reached) {
                if (this.companies_scrollable == false) {
                    this.companies_loading = true
                    /**@params = search_key, @params = sort_key, @params = sort_value, @params = status, @params = skip, @params = limit */
                    let response = await this.getCustomerList({
                        skip: this.companies_count,
                        limit: 10,
                        search_key: "",
                        status: "active",
                        sort_key:'id',
                        sort_value: -1
                    })
                    this.temp_companies = response.response.length;
                    if (response.skip == this.companies_count) {
                        if (this.temp_companies > 0) {
                            let tempFiles = response.response;
                            tempFiles.forEach(el => {
                                this.companies.push(el);
                            });
                            this.companies_count += response.response.length;
                            this.companies_loading = false
                        } else {
                            this.companies_scrollable = true
                            this.companies_loading = false
                        }
                    }
                    this.companies_loading = false
                }
            }
        },
        //API Call to Search the Product
        /**@params = item */
        async searchProductsDebouncer(item) {
            this.products_loading = true
            /**@params = search_key, @params = sort_key, @params = sort_value */
            let params = {
                search_key: item,
                sort_key:'is_star',
                sort_value:1
            }
            let response = await this.ListProducts(params)
            this.products_options = response.response
            this.products_count = this.products_options.length
            this.products_loading = false
            this.products_scrollable = false
            this.products_options.forEach(x => {
                x['product_name'] = x.name
                x['product_id'] = x.id
                x['transition_value'] = 0
            })
        },
        //Lazy laoding added for products
        /**@params = reached */
        async reachedEndOfProducts(reached) {
            this.products_visible = reached
            if (reached) {
                if (this.products_scrollable == false) {
                    this.products_loading = true
                    /**@params = skip, @params = sort_key, @params = sort_value, @params = limit */
                    let response = await this.ListProducts({
                        skip: this.products_count,
                        limit: 10,
                        sort_key:'is_star',
                        sort_value:1
                    })
                    this.temp_products = response.response.length;
                    if (response.skip == this.products_count) {
                        if (this.temp_products > 0) {
                            let tempFiles = response.response;
                            tempFiles.forEach(el => {
                                this.products_options.push(el);
                            });
                            this.products_options = this.products_options.filter((thing, index) => {
                                const payload = JSON.stringify(thing);
                                return index === this.products_options.findIndex(obj => {
                                    return JSON.stringify(obj) === payload;
                                });
                            });

                            this.products_options.forEach(x => {
                                x['product_name'] = x.name
                                x['product_id'] = x.id
                                x['transition_value'] = 0
                            })

                            this.products_count += response.response.length;
                            this.products_loading = false
                        } else {
                            this.products_scrollable = true
                            this.products_loading = false
                        }
                    }
                    this.products_loading = false
                }
            }
        },
        handleValidationError() {
            const firstField = Object.keys(this.errors.collect())[0];
            if(firstField.includes('multiselect')) {
                this.$refs[`${firstField}Input`].$el.focus();
            } else {
                this.$refs[`${firstField}Input`].focus();
            }
        },
        //API call to create/update the deals
        saveDeals(){
            this.$validator.validateAll().then(async result => {
                if(result == true){
                    try{
                        if(this.$route.params.id == 'new' || (this.$route.params.id != 'new' && (this.deal_type == 'customers' || this.deal_type == 'contacts'))){
                            // this.temp_selected_products = [];
                            this.temp_salesperson_ids = [];
                            if(this.salesperson_name.sales_person_id){
                                this.temp_salesperson_ids.push(this.salesperson_name.sales_person_id)
                            } else {
                                this.salesperson_name.forEach(el => {
                                    this.temp_salesperson_ids.push(
                                        el.sales_person_id
                                    )
                                })
                            }
                            // this.products.forEach(x => {
                            //     //push the products data into temp variable
                            //     x.product_name.forEach(y => {
                            //         this.temp_selected_products.push({
                            //             product_id: y.id,
                            //             quantity: y.quantitys ? y.quantitys : 0,
                            //             transaction_value: y.transition_value ? y.transition_value : 0,
                            //             transaction_value_per_unit: y.transition_value_perunit ? parseFloat(y.transition_value_perunit) : 0
                            //         })
                            //     })
                            // })
                            if(this.additional_info.length){
                                let temp_additional_fields = []
                                this.additional_info.forEach(x => {
                                    if(x.value && typeof x.value === 'object'){
                                        temp_additional_fields.push({
                                            id: x._id,
                                            key: x.field_name,
                                            value: x.value.value
                                        })
                                    }
                                    else if(x.value && typeof x.value !== 'object'){
                                        temp_additional_fields.push({
                                            id: x._id,
                                            key: x.field_name,
                                            value: x.value
                                        })
                                    }
                                })
                                this.create_deal['additional_info'] = temp_additional_fields
                            }
                            this.disableButtonAndDisplayLoader = true;
                            let response = await this.createDeals(this.create_deal)
                            this.deal_id = response.deal_id
                            this.success_deals = true;
                            setTimeout(() => {
                                this.disableButtonAndDisplayLoader = false;
                                this.$modal.show('success-message');
                            }, 1000)
                        }
                        else if(this.$route.params.id != 'new' && this.deal_type == null){
                            this.disableButtonAndDisplayLoader = true;
                            let response = await this.editDeals(this.$route.params.id,this.create_deal)
                            this.deal_id = this.$route.params.id
                            this.success_deals = true;
                            setTimeout(() => {
                                this.disableButtonAndDisplayLoader = false;
                                this.$modal.show('success-message');
                            }, 1000)
                        }
                    }catch(error){
                        this.warning_msg = error
                        this.disableButtonAndDisplayLoader = false;
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                } else{
                    this.disableButtonAndDisplayLoader = false;
                    return this.handleValidationError();
                }
            })
        },
        //cancel the deal creation
        cancel(){
            if(this.deal_type == 'lead'){
                this.$router.push("/listleads")
            }else{
                this.$router.go(-1)
            }
        },
        //shows the selected product
        productSelected() {
            this.total_transition = this.products.reduce(function (result, charges) {
                return result + charges.transition_value;
            }, 0);
        },
        //Calculation of the total transition
        /**@params = product */
        totalTransition(product){
            if(product.transition_value_perunit == ""){
                product.transition_value_perunit = null
            } else if(product.transition_value_perunit != null) {
                product.transition_value_perunit = product.transition_value_perunit
            }
            if(product.quantitys == ""){
                product.quantitys = null
            }
            if(product.quantitys && product.transition_value_perunit){
                product.transition_value = product.quantitys * product.transition_value_perunit
            }
            if(product.quantitys && product.transition_value_perunit == null){
                product.transition_value = product.quantitys * 0
            }
            if(product.quantitys == null && product.transition_value_perunit){
                product.transition_value = product.transition_value_perunit * 0
            }
            // if(product.quantitys != '' && product.transition_value_perunit != ''){
            //     product.transition_value = product.quantitys * parseFloat(product.transition_value_perunit)
            // }
            this.products.forEach((el, index) =>{
                this.total_transition = el.product_name.reduce(function (result, charges) {
                    return result + charges.transition_value;
                }, 0);
            })
            if (isNaN(this.total_transition)) this.total_transition = 0;
            this.$forceUpdate();
        },
        //Api call to get the additional info data
        async loadAdditionalInfo(){
            /**@params = skip, @params = limit, @params = search_key, @params = sort_key, @params = sort_value, @params = sub_module_name */
            let params = {
                limit: 50,
                search_key: "",
                skip: 0,
                sort_key: "",
                sort_value: -1,
                sub_module_name: "deals"
            }
            let response = await this.getAdditionalInformationList(params)
            this.additional_info = response.response
            this.additional_info.forEach(x => {
                x['value'] = null
            })
            if(this.additional_info.length){
                this.check_visibility = this.additional_info.every(x => x.visibility === false)
            }
        }
    },
    mounted(){
        this.transition_format = this.loggedInUser.currency.symbol;
        this.owner_name = this.loggedInUser.full_name;
        let meetingData = JSON.parse(localStorage.getItem("meeting_id"))
        if(meetingData){
            this.meeting_id = meetingData
            this.getMeetingData();
        }else{
            meetingData = ""
        }
        //get the deal type from local storage
        let data = JSON.parse(localStorage.getItem("deal_type"))
        if(data){
            this.deal_type = data.deal_type
            if(this.deal_type == 'lead' && this.$route.params.id == 'new'){
                if(data.value.company_name !== ''){
                    this.company_name = {
                        id: data.value.customer_id,
                        customer_name: data.value.company_name
                    }
                } else {
                    this.customer_auto_fill = true;
                }
                if(data.value.contact_name !== ''){
                    this.contact_name = {
                        id: data.value.contact_id,
                        full_name: data.value.contact_name
                    }
                    this.customer_id=data.value.customer_id
                }
            }
            else if(this.deal_type == 'customers' && this.$route.params.id != 'new' ){
                this.company_name = data.value
                this.customer_id = data.id
                this.$forceUpdate()
            }
            else if(this.deal_type == 'contacts' && this.$route.params.id != 'new'){
                this.contact_name = data.value
                if(data.value.company_name !== ''){
                    this.customer_auto_fill = true;
                    this.company_name = {
                        id: data.value.customer_id_id,
                        customer_name: data.value.company_name
                    }
                    this.customer_id = data.value.customer_id
                } else {
                    this.company_name = '';
                    this.customer_auto_fill = true;
                }
                this.$forceUpdate()
            }
        }
        this.loadSalespersonListDebouncer();
        setTimeout(() => {
            this.salesperson_name = this.temp_salesperson_name[0];
        }, 2000);
        this.owner_name = this.loggedInUser.full_name;
        this.transition_format = this.loggedInUser.currency.symbol;
        this.loadAdditionalInfo();
        this.searchContactName();
        this.fetchContactName();
    },
    computed: {
        // totalTransitions(){
        //     return this.products[0].product_name.reduce((acc, obj) =>
        //         acc + obj.transition_value, 0
                // this.total_transition = this.products.reduce(function (result, charges) {
                //     return result + charges.transition_value;
                // }, 0);
        //     )
        // },
        searchProuctName(){
            return debounce(this.searchProuctNameDebouncer, 500)
        },
        loggedInUser() {
            return this.$store.state.loggedInUser;
        },
        //pass thi as params while creating/updating the deals
        create_deal(){
            this.products.forEach(x => {
                x.product_name.forEach((el_product, el_product_index) => {
                    if(this.template_data.length > 0){
                        if(el_product._id == value._id){
                            this.temp_selected_products.push({
                                product_id: el_product._id,
                                product_name: el_product.name,
                                quantity: el_product.quantitys ? el_product.quantitys : 0,
                                transaction_value: el_product.transition_value ? el_product.transition_value : 0,
                                transaction_value_per_unit: el_product.transition_value_perunit ? parseFloat(el_product.transition_value_perunit) : 0,
                                template_details: value.template_details ? value.template_details : []
                            })
                        }
                    }else{
                        this.temp_selected_products.push({
                            product_id: el_product._id,
                            product_name: el_product.name,
                            quantity: el_product.quantitys ? el_product.quantitys : 0,
                            transaction_value: el_product.transition_value ? el_product.transition_value : 0,
                            transaction_value_per_unit: el_product.transition_value_perunit ? parseFloat(el_product.transition_value_perunit) : 0,
                            template_details: el_product.template_details ? el_product.template_details : []
                        })
                    }
                 })
            })
            return{
                from_lead: false,
                name: this.deal_name,
                owner_id: this.loggedInUser.user_id,
                owner_name: this.loggedInUser.full_name,
                contact_id: this.contact_name.id,
                customer_id: this.customer_id,
                priority: this.priority == 'High' ? 'high' : this.priority == 'Low' ? 'low' : 'medium',
                expected_close_date: this.expected_date,
                // forecast_category: this.forecast == 'Best Case' ? 'best_case' : this.forecast == 'Pipeline' ? 'pipeline' : 'commit',
                total_transaction_value: this.total_transition,
                // expected_revenue: this.expected_revenue,
                deal_pipeline_id: this.deal_pipeline.id,
                products: this.temp_selected_products,
                deal_territory_id: this.territory_id,
                deals_sales_person_id : this.temp_salesperson_ids,
                permissions: {
                    general_access: this.general_access,
                    individual_permission_list: this.permissions.individual_permission_list,
                    team_permission_list: this.permissions.team_permission_list,
                }
            }
        },
        userPermissions(){
            return this.$store.getters.userPermissions;
        }
    },
    created() {
        this.selected_status = this.$route.params.data
        const dict = {
            custom: {
                deal_name: {
                    required: () => "Deal Name is required"
                },
                // forecast: {
                //     required: () => "Forecast Category is required"
                // },
                deal_pipeline_multiselect: {
                    required: () => "Deal Pipeline is required"
                },
                contact_name: {
                    required: () => "Contact Name is required"
                },
                total_transition: {
                    required: () => "Total Transaction is Required"
                },
                quantitys: {
                    // required: () => "Quantity is Required",
                    numeric: () => "Quantity must contain only Numericals",
                    max:() => "Please Enter 5 digits only"
                },
                // expected_revenue: {
                //     required: () => "Expected revenue  is Required",
                //     numeric: () => "Expected revenue must contain only Numericals"
                // }
            }
        };
        this.$validator.localize("en", dict);
        this.addedProduct = JSON.parse(localStorage.getItem("AddedProducts"))
        //Added debounce to all search
        //this.searchContactName = debounce(this.searchContactNameDebouncer, 500)
        //this.searchCompany = debounce(this.searchCompanyDebouncer, 500)
        // this.searchForecastType = debounce(this.searchForecastTypeDebouncer, 500)
        this.searchProducts = debounce(this.searchProductsDebouncer, 500)
        this.loadSalespersonList = debounce(this.loadSalespersonListDebouncer, 500)
        this.searchIndividuals = debounce(this.searchIndividualsDebounce, 500)
        this.searchTeam = debounce(this.searchTeamDeounce, 500)
    },
}
</script>
<style scoped>
    .add-new-field{
        background-color: transparent;
        outline: 0 none !important;
    }
    .main-div {
        background: #fff;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .create-company-container {
        background-color: #fff;
        padding: 0px 0 0px 0;
        border-radius: 5px;
    }

    .create-company-header {
        padding: 9.9px 15px;
        background-color: #00448b;
    }
    .input-label {
        font-weight: 600;
        line-height: 1.5;
        letter-spacing: 0.39px;
        text-align: left;
        color: #00448b;
        padding: 0 0 6px 0px;
        font-size: 14px;
    }
    .input-field {
        border-radius: 6px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100% !important;
        height: 40px;
    }
    .input-width {
        border-radius: 5px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100% !important;
        height: 40px !important;
    }
    .btn-new-cancel {
        color: #d51650;
        background-color: #fff;
        border-radius: 5px;
        text-transform: none;
        font-weight: 600;
        border: 1px solid #d51650;
        line-height: 30px;
        box-shadow: none;
    }
    .btn-new-save {
        border: 2px solid #008a63;
        line-height: 30px;
        border-radius: 5px;
        background-color: #008a63;
    }
    .reset-btn {
        border: 2px solid #128809;
        line-height: 30px;
        border-radius: 18px;
        background-color: #128809;
        color: #fff;
        font-weight: 600;
        padding: 0px 12px;
        cursor: pointer;
    }
    .mx-datepicker.date-white .mx-input-wrapper input.mx-input {
        height: 32px !important;
        color: #fff !important;
        font-weight: 600 !important;
        font-size: 13px !important;
    }
    .mx-input {
        /* border-bottom: 1px solid #fff !important; */
        display: inline-block;
        height: 0px !important;
    }
    .v-hidden {
        visibility: hidden;
    }

    i,
    [class^="icon-"] {
        line-height: 0px !important;
    }
    .text-green {
        color: #008a63 !important;
    }
    .pointer-event {
        background-color: #fff !important;
    }
    .input-date-position{
        position: relative;
        bottom: 7px;
    }
    .text-secondary {
        color: #00448b !important;
    }
    .select-width{
        width:80px;
        height:40px;
        border-radius: 5px;
    }
    .icon-width {
        width: 20px;
        height: 20px;
    }
    .icon-color {
        color:#ff9a06
    }
    .text-line {
        text-decoration :none !important;
    }
    .w-200px{
        /* width: 100px; */
        max-width: 230px;
    }
    .round-4px {
        border-radius: 4px;
    }
    .team-list-table{
        margin-left: 16px;
        margin-right: 26px;
    }
    .team-list-table thead tr th {
        background: #005dae;
        color: #fff;
        padding: 10px 20px;
        font-size: 14px;
        font-weight: 500;
        white-space: nowrap;
        border: 1px solid darkgray;
    }
    .team-list-table thead tr th:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }
    .team-list-table thead tr th:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    .team-list-table tbody tr td {
        background: #fff;
        padding: 8px 20px 20px 20px;
        font-size: 14px;
        font-weight: 500;
        border: 1px solid darkgray;
        white-space: nowrap;
    }
    .team-list-table tbody tr td span img {
        width: 30px !important;
        height: 30px !important;
        margin-left: -10px;
    }
    .prod-name-col{
        max-width: 100px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Deals/createDealsNew.vue